<div>
  <div class="row">
    <div class="offset-md-2 col-md-8">
      <div class="card">
        <div class="card-body">
          <form [formGroup]="form" (submit)="submit()">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="name">Key</label>
                  <input type="text" class="form-control" formControlName="key" [ngClass]="getValidationClass('key')" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="name">Description</label>
                  <textarea
                    maxlength="1024"
                    type="text"
                    class="form-control"
                    formControlName="description"
                    [ngClass]="getValidationClass('description')"></textarea>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="name">Type</label>
                  <select class="form-control" formControlName="type" [ngClass]="getValidationClass('type')">
                    <option *ngFor="let t of types" [ngValue]="t">{{ t.label }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="name">Value</label>

                  <ng-container [ngSwitch]="this.form.value.type.value">
                    <ng-container *ngSwitchCase="SettingType.MULTILINE_STRING">
                      <textarea
                        type="text"
                        class="form-control"
                        formControlName="value"
                        rows="5"
                        [ngClass]="getValidationClass('value')"></textarea>
                    </ng-container>

                    <ng-container *ngSwitchCase="SettingType.BOOLEAN">
                      <input style="width: 25px" type="checkbox" class="form-control" formControlName="value" />
                    </ng-container>

                    <ng-container *ngSwitchCase="SettingType.NUMBER">
                      <input
                        type="number"
                        class="form-control"
                        formControlName="value"
                        [ngClass]="getValidationClass('value')" />
                    </ng-container>

                    <ng-container *ngSwitchDefault>
                      <input
                        type="text"
                        class="form-control"
                        formControlName="value"
                        [ngClass]="getValidationClass('value')" />
                    </ng-container>
                  </ng-container>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="name"
                    >Visible to Inspector
                    <input
                      style="width: 25px"
                      type="checkbox"
                      class="form-control"
                      formControlName="visibleToInspector"
                  /></label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <button class="btn btn-primary" [disabled]="!form.valid">Save</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
